<template>
  <span class="gmf-loading-spinner"></span>
</template>
<style>
.gmf-loading-spinner {
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  border-top: 2px solid var(--gmf-col-nearblack);
  animation: gmf-spinner 0.5s linear infinite; 
}
@keyframes gmf-spinner {
  to { transform: rotate(360deg); }
}
</style>
<script>
export default {
  data () {
    return {};
  }
};
</script>